import React from 'react'
import { BASE_URL } from '../../../../Utilities/APIs'

function Image({imgSrc, imgAlt }) {
  return (
    <img src={imgSrc ? BASE_URL + imgSrc.slice(6, imgSrc.length) : 'http://backend.khoj.info//images/organizationCardImages/1665638993697--1737502536096950.jpeg'} alt={imgAlt} />
  )
}

export default Image